import * as React from 'react';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IInstantOfferDetails } from './InstantOffers';
import { buildScheduleIneligibleOfferLink, makeModelMaxLength } from './utils/constants';

export interface IIneligibleOfferProps {
    instantOfferDetails: IInstantOfferDetails;
}

function prepareVehicleTitle(make: string | undefined, model: string | undefined) {
    const vehicleTitle = make + ' ' + model;

    if (make && model && vehicleTitle.length <= makeModelMaxLength) {
        return vehicleTitle;
    } else if (make && make.length <= makeModelMaxLength) {
        return make;
    } else {
        return 'car';
    }
}

function IneligibleOffer(props: IIneligibleOfferProps) {
    const vehicleTitle = prepareVehicleTitle(
        props.instantOfferDetails.vehicleMake,
        props.instantOfferDetails.vehicleModel
    );

    return (
        <Paper
            id="icoIneligible"
            elevation={2}
            sx={{ padding: 4, borderRadius: 2, maxWidth: { sm: '20.5rem', md: '24rem' } }}
        >
            <Stack spacing={2}>
                <Typography variant="h5">We&apos;d like to see your {vehicleTitle} in&nbsp;person</Typography>
                <Typography component="p" variant="body2">
                    Online offers are based on recent appraisals of similar cars, and we haven&apos;t seen many like
                    yours lately. For your offer, stop by your local CarMax.
                </Typography>
            </Stack>
            <Stack spacing={1} sx={{ mt: 3 }}>
                <Button
                    variant="contained"
                    href={buildScheduleIneligibleOfferLink()}
                    target="_blank"
                    rel="noopener noreferrer"
                    fullWidth
                >
                    Schedule in-store appraisal
                </Button>
                <Button
                    variant="outlined"
                    className="ico-ineligible-change-vehicle-btn"
                    onClick={props.instantOfferDetails.onStartNewOffer}
                >
                    Change vehicle
                </Button>
            </Stack>
        </Paper>
    );
}

export default IneligibleOffer;
